import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import ChatPage from './ChatPage';
import NetSuitePage from './NetSuitePage';
import DashboardPage from './DashboardPage';
import MarketingPage from './MarketingPage';
import DeckBuilderPage from './DeckBuilderPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/netsuite" element={<NetSuitePage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/marketing" element={<MarketingPage />} />
        <Route path="/deck-builder" element={<DeckBuilderPage />} />
        <Route path="/oauth-callback" element={<DashboardPage />} />
      </Routes>
    </BrowserRouter>
  );
}
